/* import __COLOCATED_TEMPLATE__ from './tooltips-messenger-not-loaded.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();